import { render, staticRenderFns } from "./DashboardFoodFree.vue?vue&type=template&id=6dbe7024"
import script from "./DashboardFoodFree.vue?vue&type=script&lang=js"
export * from "./DashboardFoodFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports